import { Action } from "../../../action";
import { DefaultApi } from "../../../api";
import { getCatchError } from "../../../getCatchError";
import { urls } from "../../../urls";

const setGetHistoryBonusGetById = (params) => {
    return async (dispatch, getState) => {
        try {
            const { data } = await DefaultApi({
                params,
                method: 'get',
                url: urls.GET_USER_HISTORY_BONUSES
            });

            if (data.status === 'success') {
                const bonuses = [...getState().usersMobile.bonuses_history.data];
                bonuses.push(data.data);

                dispatch(Action.SetGetHistoryBonusGetByIdAction({
                    data: bonuses.flat(1),
                    countPage: data.count
                }));
                dispatch(Action.SetLoadingAction(false))
            }
        } catch (error) {
            getCatchError(error)
        }
    }
}

export {
    setGetHistoryBonusGetById as SetGetHistoryBonusGetById
}